export default "__VITE_ASSET__CO8vRA$A__"